/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CrmFileCategoryResponse } from '../models/CrmFileCategoryResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CrmConfigFileCategoriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns CrmFileCategoryResponse
     * @throws ApiError
     */
    public getCrmConfigFileCategoriesIndex(): CancelablePromise<Array<CrmFileCategoryResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/crm/config/file-categories',
        });
    }

    /**
     * @returns CrmFileCategoryResponse
     * @throws ApiError
     */
    public postCrmConfigFileCategoriesCreate({
        requestBody,
    }: {
        requestBody: {
            name: string;
        },
    }): CancelablePromise<CrmFileCategoryResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/crm/config/file-categories',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns CrmFileCategoryResponse
     * @throws ApiError
     */
    public putCrmConfigFileCategoriesUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: {
            name: string;
        },
    }): CancelablePromise<CrmFileCategoryResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/crm/config/file-categories/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public deleteCrmConfigFileCategoriesDelete({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/crm/config/file-categories/{id}',
            path: {
                'id': id,
            },
        });
    }

}
